import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemsSection } from './components/ProblemsSection';
import { ProductPresentation } from './components/ProductPresentation';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { CountdownSection } from './components/CountdownSection';
import { PricingSection } from './components/PricingSection';
import { PackEliteComparison } from './components/PackEliteComparison';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { CostComparisonTable } from './components/CostComparisonTable';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-agua selection:text-white flex flex-col" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemsSection data-id="element-2" />
      <ProductPresentation data-id="element-3" />
      <TomosSection data-id="element-4" />
      <BonosSection data-id="element-5" />
      <CountdownSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <PackEliteComparison data-id="element-8" />
      <TestimonialsSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <FaqSection data-id="element-11" />
      <CostComparisonTable data-id="element-12" />

      {/* Second instance of Countdown and Pricing to close the page */}
      <div className="mt-4 sm:mt-8" data-id="element-13">
        <CountdownSection data-id="element-14" />
        <PricingSection data-id="element-15" />
      </div>

      <Footer data-id="element-16" />
    </div>;
}